import {
    SET_STATUS,
} from "./StatusType";

const reducer = (state = [], action: any) => {
    switch (action.type) {
        case SET_STATUS:
            return {
                ...state,
                statusDropDown: action.statusDropDown,
            };
        default:
            return state;
    }
};

export default reducer;
